import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import * as palette from "../../palette";

interface IBrazilianCompanyIssuerTagAlongProps {
  tagAlong: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["tagAlong"]>;
}

export default function BrazilianCompanyIssuerTagAlong({ tagAlong }: IBrazilianCompanyIssuerTagAlongProps) {
  return (
    <div className="space-y-2 font-aeonik text-sm font-bold xl:text-sm">
      {tagAlong.commonStock !== null && (
        <div
          aria-label={`${tagAlong.commonStock}% de Tag Along nas Ações Ordinárias`}
          style={{
            color: getColorByPercentage(tagAlong.commonStock),
          }}
        >
          {tagAlong.commonStock}% ON
        </div>
      )}

      {tagAlong.preferredStock !== null && (
        <div
          aria-label={`${tagAlong.preferredStock}% de Tag Along nas Ações Preferenciais`}
          style={{
            color: getColorByPercentage(tagAlong.preferredStock),
          }}
        >
          {tagAlong.preferredStock}% PN
        </div>
      )}

      {tagAlong.unitStock !== null && (
        <div
          aria-label={`${tagAlong.preferredStock}% de Tag Along nas UNITs`}
          style={{
            color: getColorByPercentage(tagAlong.unitStock),
          }}
        >
          {tagAlong.unitStock}% UNIT
        </div>
      )}
    </div>
  );
}

function getColorByPercentage(tagAlongPercentage: number): string {
  if (tagAlongPercentage === 100) {
    return palette.oceanGreen;
  }

  if (tagAlongPercentage >= 80 && tagAlongPercentage < 100) {
    return palette.copper;
  }

  return palette.mojo;
}
